export default __webpack_public_path__ + "static/media/i_pill_calendar.205d8d47.svg";